import React, { useEffect, useRef, useState, memo } from "react";

const MAX_CHAT_LENGTH = 200;

const ChatBox = memo(({ addChatMessage, chatMessages, username }) => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  const send = () => {
    const text = inputValue.trim();
    if (!text) return;
    addChatMessage(text, username);
    setInputValue("");
  };

  const handleKeyDown = (event) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    send();
    inputRef.current?.focus();
  };

  useEffect(() => {
    // Only steal focus where a keyboard is already present. On a phone this
    // used to open the on-screen keyboard the moment the game loaded, which
    // scrolled the board out of view before anyone had touched anything.
    const finePointer = window.matchMedia?.("(pointer: fine)")?.matches;
    if (finePointer) inputRef.current?.focus();
  }, []);

  return (
    <>
      <div className="chat-box">
        <div>
          {chatMessages.length === 0 && (
            <p className="chat-empty">No messages yet.</p>
          )}
          {chatMessages.map((message, index) => {
            if (message.systemType) {
              return (
                <div
                  className={`chat-message system-message-${message.systemType}`}
                  key={index}
                >
                  <strong>{message.content}</strong>
                </div>
              );
            }

            return (
              <div className="chat-message" key={index}>
                <strong style={{ color: message.color }}>
                  {message.author}
                </strong>{" "}
                {message.content}
              </div>
            );
          })}
        </div>
      </div>
      <input
        type="text"
        placeholder="Type a message..."
        aria-label="Chat message"
        maxLength={MAX_CHAT_LENGTH}
        enterKeyHint="send"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        ref={inputRef}
      />
    </>
  );
});

export default ChatBox;
